var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/SelectDependencies/tabIndex.ts";
export var TabIndex;

(function (TabIndex) {
  TabIndex[TabIndex["ModelRepo"] = 0] = "ModelRepo";
  TabIndex[TabIndex["ClassifierRepo"] = 1] = "ClassifierRepo";
  TabIndex[TabIndex["EstimationRepo"] = 2] = "EstimationRepo";
})(TabIndex || (TabIndex = {}));